module.exports = __webpack_public_path__ + "img/validations.93478b1d.svg";